import React from 'react';
import Reflux from 'reflux';
import './ErrorSign.css';
import RcIf from 'rc-if';

class ErrorSign extends Reflux.Component {
    constructor (props) {
        super(props);
        let visible = (props.title && props.description);
        this.state = {
            visible: visible
        };
    }
    hideSign = () => {
        this.setState({visible: false});
    }
    componentWillReceiveProps (nextProps) {
        if (nextProps.title && nextProps.description) {
            this.setState({visible: true});
        }
    }
    render () {
        return (

          <RcIf if={this.state.visible}>
            <div className='error-container'>
              <div className='top-error'>
                <p><img src='/images/icons/error-sign.svg' /><span>{this.props.title}.</span> {this.props.description}</p>
                <a onClick={this.hideSign}><img src='/images/icons/close-sign.svg' /></a>
              </div>
            </div>
          </RcIf>
        );
    }
}

export default ErrorSign;



// WEBPACK FOOTER //
// ./src/sections/ErrorSign.js